import { Link } from 'react-router-dom';
import { ArrowLeft, Trophy, Award, Star, ExternalLink } from 'lucide-react';

const WINNERS = [
  {
    place: 1,
    label: 'Winner',
    name: 'Emmanuel Olateju',
    project: 'Development of an Instrument for Automatic Schizophrenia Diagnosis',
    supervisor: 'Dr. K.P. Ayodele',
    prize: '₦250,000',
    color: 'var(--gold)',
    image: '/images/season1/DSC_3813.jpg',
  },
  {
    place: 2,
    label: '1st Runner-Up',
    name: 'Victor Olufemi',
    project: 'Development of A Transfer Calibration & Decentralized Storage for IoT-Compliant Carbon Emissions Monitoring System',
    supervisor: 'Dr F.B Offiong',
    prize: '₦150,000',
    color: '#c0c0c0',
    image: '/images/season1/DSC_3837.jpg',
  },
  {
    place: 3,
    label: '2nd Runner-Up',
    name: 'Oladoyin Arewa',
    project: 'Development of a Power Supply Unit with Hybrid Energy Storage Subsystem for Use in Low-Cost Weather Stations',
    supervisor: 'Dr. K.P. Ayodele',
    prize: '₦75,000',
    color: '#cd7f32',
    image: '/images/season1/DSC_3781.jpg',
  },
];

const JUDGES = [
  { name: 'Roseline Ilori', role: 'Former CEO, MTech Communications', image: '/uploads/judge_headshots/00cefeffaea3a9c73341c9dc8a4c6b6a6e4fff89.jpg', linkedin: 'https://www.linkedin.com/in/roseline-ilori/' },
  { name: 'Dr. Adedayo Omotunde', role: 'Telecoms Executive & DBA, Swiss Business School', image: '/images/season1/Dr-Adedayo-Omotunde.jpg', linkedin: 'https://ng.linkedin.com/in/adedayoomotunde' },
  { name: 'Folu Dele-Ijagbulu', role: 'CEO, BuySimply | MBA INSEAD | OAU Valedictorian', image: '/uploads/judge_headshots/fiyinfolu_dele_ijagbulu.jpg', linkedin: 'https://www.linkedin.com/in/foludeleijagbulu/' },
  { name: 'Kess Atuyota', role: 'PMP | AWS Architect | Technology Executive', image: '/uploads/judge_headshots/kess_atuyota.jpg', linkedin: 'https://www.linkedin.com/in/kessatuyota/' },
  { name: 'Dr. Olawale B. Akinwale', role: 'Lecturer, OAU EEE | MIT-ETT Fellow', image: '/uploads/judge_headshots/0f1992e72a105fb6b978f11f52457f265926604c.jpg', linkedin: 'https://www.linkedin.com/in/olawale-akinwale-b9105bb/' },
];

const GALLERY = [
  '/images/season1/DSC_3699.jpg',
  '/images/season1/DSC_3692.jpg',
  '/images/season1/DSC_3802.jpg',
  '/images/season1/DSC_3830.jpg',
  '/images/season1/DSC_3639.jpg',
];

export default function Season1Page() {
  return (
    <div style={{ background: 'var(--surface-body)', minHeight: '100vh', color: 'var(--text-primary)' }}>
      {/* Nav */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, height: 72, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 40px', background: 'rgba(10,12,20,0.85)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', color: 'var(--gold)' }}>Futurum Innovation Awards</div>
        <Link to="/register" className="btn btn-primary btn-sm">Apply for Season II</Link>
      </nav>

      {/* Hero */}
      <div style={{ paddingTop: 72, background: 'linear-gradient(135deg, rgba(201,162,39,0.08) 0%, rgba(45,212,191,0.04) 50%, transparent 100%)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', padding: '80px 40px 60px', textAlign: 'center' }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Obafemi Awolowo University · EEE Department · 2023</div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', fontWeight: 300, lineHeight: 1.1, marginBottom: 24 }}>
            Season <span style={{ color: 'var(--gold)', fontStyle: 'italic' }}>One</span> Highlights
          </h1>
          <p style={{ fontSize: '1.1rem', color: 'var(--text-secondary)', maxWidth: 600, margin: '0 auto 40px', lineHeight: 1.7 }}>
            The inaugural Futurum Innovation Awards brought together OAU's brightest final-year EEE students to compete for recognition and funding. Three outstanding projects emerged as winners.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 48, flexWrap: 'wrap' }}>
            {[['3', 'Finalists'], ['5', 'Industry Judges'], ['₦475,000', 'Total Prizes'], ['2023', 'Inaugural Season']].map(([val, label]) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--gold)', fontWeight: 600 }}>{val}</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.1em', marginTop: 4 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* YouTube Video */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '60px 40px 0' }}>
        <div className="eyebrow" style={{ textAlign: 'center', marginBottom: 16 }}>Event Recording</div>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 400, textAlign: 'center', marginBottom: 32 }}>Watch the Season 1 Finale</h2>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, borderRadius: 16, overflow: 'hidden', border: '1px solid rgba(201,162,39,0.2)' }}>
          <iframe
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            src="https://www.youtube.com/embed/7ykV9ZAQ_-Q"
            title="Futurum Innovation Awards Season 1 Finale"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      {/* Winners */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '80px 40px 0' }}>
        <div className="eyebrow" style={{ textAlign: 'center', marginBottom: 16 }}>Award Winners</div>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '2.5rem', fontWeight: 400, textAlign: 'center', marginBottom: 48 }}>
          The <span style={{ color: 'var(--gold)', fontStyle: 'italic' }}>Champions</span> of Season One
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
          {WINNERS.map(w => (
            <div key={w.place} className="card" style={{ border: `1px solid ${w.color}33`, position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, ${w.color}, transparent)` }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', background: `${w.color}22`, border: `1px solid ${w.color}44`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {w.place === 1 ? <Trophy size={18} style={{ color: w.color }} /> : <Award size={18} style={{ color: w.color }} />}
                </div>
                <div>
                  <div style={{ fontSize: '0.7rem', fontFamily: 'var(--font-mono)', letterSpacing: '0.1em', textTransform: 'uppercase', color: w.color }}>{w.label}</div>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', fontWeight: 500 }}>{w.name}</div>
                </div>
                <div style={{ marginLeft: 'auto', fontFamily: 'var(--font-mono)', color: w.color, fontWeight: 600 }}>{w.prize}</div>
              </div>
              <img src={w.image} alt={w.name} style={{ width: '100%', height: 200, objectFit: 'cover', borderRadius: 8, marginBottom: 16 }} />
              <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 8 }}>{w.project}</p>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Supervisor: {w.supervisor}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Gallery */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '80px 40px 0' }}>
        <div className="eyebrow" style={{ textAlign: 'center', marginBottom: 16 }}>Event Gallery</div>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 400, textAlign: 'center', marginBottom: 40 }}>Moments from the Finale</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
          {GALLERY.map((src, i) => (
            <div key={i} style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.06)', aspectRatio: '3/2' }}>
              <img src={src} alt={`Season 1 event photo ${i + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s ease' }}
                onMouseEnter={e => e.target.style.transform = 'scale(1.03)'}
                onMouseLeave={e => e.target.style.transform = 'scale(1)'}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Judges */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '80px 40px 0' }}>
        <div className="eyebrow" style={{ textAlign: 'center', marginBottom: 16 }}>Panel of Judges</div>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 400, textAlign: 'center', marginBottom: 40 }}>
          Industry <span style={{ color: 'var(--teal)', fontStyle: 'italic' }}>Experts</span>
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 20 }}>
          {JUDGES.map(j => (
            <div key={j.name} className="card" style={{ textAlign: 'center', padding: 24 }}>
              <img src={j.image} alt={j.name} style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', margin: '0 auto 12px', border: '2px solid rgba(201,162,39,0.3)' }} />
              <div style={{ fontWeight: 600, fontSize: '0.95rem', marginBottom: 4 }}>{j.name}</div>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', lineHeight: 1.5, marginBottom: 12 }}>{j.role}</div>
              <a href={j.linkedin} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '0.75rem', color: 'var(--teal)' }}>
                LinkedIn <ExternalLink size={10} />
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* Scoring Criteria */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '80px 40px 0' }}>
        <div className="eyebrow" style={{ textAlign: 'center', marginBottom: 16 }}>Judging Framework</div>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 400, textAlign: 'center', marginBottom: 40 }}>Scoring Criteria</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 16 }}>
          {[
            { title: 'Originality & Creativity', points: 20, desc: 'Innovation, out-of-the-box thinking, and creative problem solving.' },
            { title: 'Technical Merit', points: 20, desc: 'Technical proficiency, execution quality, and clarity of explanation.' },
            { title: 'Feasibility', points: 20, desc: 'Real-world viability given current resources and technology.' },
            { title: 'Impact', points: 20, desc: 'Positive impact on society, environment, or the target industry.' },
            { title: 'Presentation & Delivery', points: 20, desc: 'Clarity, engagement, and quality of presentation materials.' },
          ].map(c => (
            <div key={c.title} className="card card-teal" style={{ padding: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{c.title}</div>
                <div style={{ fontFamily: 'var(--font-mono)', color: 'var(--gold)', fontSize: '0.85rem' }}>{c.points} pts</div>
              </div>
              <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', lineHeight: 1.6 }}>{c.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '80px 40px', textAlign: 'center' }}>
        <div className="eyebrow" style={{ marginBottom: 16 }}>Season II is Open</div>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 400, marginBottom: 20 }}>
          Ready to make your <span style={{ color: 'var(--gold)', fontStyle: 'italic' }}>mark?</span>
        </h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 32, lineHeight: 1.7 }}>
          Season II is now open for students, alumni sponsors, and lecturers at OAU EEE. Join the next generation of engineering innovation.
        </p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/register" className="btn btn-primary btn-lg">Apply for Season II</Link>
          <Link to="/" className="btn btn-secondary btn-lg">Learn More</Link>
        </div>
      </div>

      {/* Footer */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '24px 40px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>
        Futurum Innovation Awards · Pervium Consulting × OAU EEE · <a href="https://perviumconsulting.com/futurum/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--teal)' }}>perviumconsulting.com/futurum</a>
      </div>
    </div>
  );
}
